// extracted by mini-css-extract-plugin
export default {"heading":"GemDetail_heading__Lnlb0","list":"GemDetail_list__5XmXS","li":"GemDetail_li__tgOz8"};